import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login-layout',
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.css'],
    standalone: false
})
export class LoginLayoutComponent implements OnInit {

  isBrokerSignup: boolean = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    this.isBrokerSignup = this.router.url.includes('/registration');
  }

}
